// extracted by mini-css-extract-plugin
module.exports = {"timePickerContainer":"PromotionSchedule_timePickerContainer__15TL8 cx-5","timeIcon":"PromotionSchedule_timeIcon__1swGZ"};